export const VENDOR_EDITABLE_STATUSES_FOR_PO = [
  "pre_draft",
  "draft",
  "pending_invoice_upload",
  "pending_invoice_verification",
  "awaiting_grn",
  "issue_in_invoice_upload",
  "closed",
  "issue_in_grn",
];

export const CLINIC_DETAILS_EDITABLE_STATUSES_FOR_PO = [
  "pre_draft",
  "draft",
  "pending_invoice_upload",
  "pending_invoice_verification",
  "issue_in_invoice_upload",
];

export const INVOICE_DATE_AND_NUMBER_EDITABLE_STATUSES_FOR_PO = [
  "pending_invoice_upload",
  "issue_in_invoice_upload",
  "pending_invoice_verification",
  "awaiting_grn",
  "closed",
  "issue_in_grn",
];
